import React from "react";
import DSDModuleSubtopic from "../DSDModuleSubtopic";

const DesignOfCountersModule = () => (
  <DSDModuleSubtopic
    title="Design of Counters"
    videos={[
      "https://www.youtube.com/embed/AKe2T5BkI1U",
      "https://www.youtube.com/embed/fyagSrWSWbc",
      "https://www.youtube.com/embed/svFUEJkoeVY",
      "https://www.youtube.com/embed/gvLKdxFt5gY",
      "https://www.youtube.com/embed/ome5V3jTqpc",
      "https://www.youtube.com/embed/pZ6OP2muIZg"
    ]}
    takeaways={[]}
    questions={[
      { text: "Design a 3 bit counter using T Flip Flip that counts through the sequence 0,1,3,5,7,0…." },
      { text: "Design a 3 bit counter using D Flip Flop that counts through the sequence 0,2,4,6,0…." },
      { text: "Design a modulo 8 up/down counter with control input. Write a Verilog Code for the design." },
      { text: "Write behavioural level Verilog HDL for an eight bit Ring Counter and Johnson Counter." },
      { text: "Design a 4-bit counter that counts from 0 to 10 using D Flip Flop and provide necessary circuit diagram." },
      { text: "Design a circuit for a positive edge triggered 4-bit binary up counter (0000 to 1111). When it reaches '1111', It should revert back to '0000' after the next edge. Use positive edge triggered D Flip Flop to design the circuit." },
      { text: "Design a synchronous counter using D Flip Flop for the sequence 4 -> 2 -> 5 -> 1 -> 7 -> 4…., Write a D Flip Flop using behavioural modelling Verilog HDL and counter using structural modelling." },
      { text: "Consider the following state transition table for a counter. Q2,Q1 and Q0 represent the current state of the counter and N2, N1 and N0 represent the next counter state (a) Draw the state transition diagram for the counter (b) Implement the counter using T Flip Flop and external gates.",
        image:"/dsd_21.png"
       }
    ]}
    exampleVideos={[]}
  />
);

export default DesignOfCountersModule;
